import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ClarityTracker component that initializes Microsoft Clarity and tracks page views
 * on route changes for Single Page Applications (SPAs)
 */
function ClarityTracker() {
  const location = useLocation();

  // Initialize Clarity script on mount
  useEffect(() => {
    const clarityId = process.env.REACT_APP_CLARITY_ID;
    
    if (!clarityId) {
      if (process.env.NODE_ENV === 'development') {
        console.warn('Microsoft Clarity: REACT_APP_CLARITY_ID not set. Clarity tracking is disabled.');
      }
      return;
    }

    // Check if Clarity is already initialized
    if (window.clarity) {
      return;
    }

    // Initialize Microsoft Clarity
    (function(c, l, a, r, i, t, y) {
      c[a] = c[a] || function() { (c[a].q = c[a].q || []).push(arguments); };
      t = l.createElement(r);
      t.async = 1;
      t.src = "https://www.clarity.ms/tag/" + i;
      y = l.getElementsByTagName(r)[0];
      y.parentNode.insertBefore(t, y);
    })(window, document, "clarity", "script", clarityId);

    if (process.env.NODE_ENV === 'development') {
      console.log('Microsoft Clarity initialized with ID:', clarityId);
    }
  }, []); // Only run once on mount

  // Track page views on route changes
  useEffect(() => {
    if (!window.clarity) {
      return;
    }

    // Clarity automatically tracks page views, but for SPAs we can ensure
    // proper tracking by using the identify method or letting it auto-track
    // The script automatically handles SPA route changes
    try {
      // Clarity's script automatically tracks route changes in SPAs
      // We can optionally use clarity.identify() for custom tracking if needed
      if (process.env.NODE_ENV === 'development') {
        console.log('Clarity: Page view tracked for', location.pathname);
      }
    } catch (error) {
      console.error('Clarity tracking error:', error);
    }
  }, [location.pathname]);

  return null; // This component doesn't render anything
}

export default ClarityTracker;
